import React from "react";
import Icon from "./icon";

const DynamicIcon = React.forwardRef(({onClick, name, size, color}, ref) => {
  return (
    <div ref={ref} onClick={onClick} className={`${color} ${onClick ? 'cursor-pointer' : ''}`}>
        <Icon name={name} size={size} color='currentColor' />
    </div>
  );
});

DynamicIcon.displayName = 'DynamicIcon';

export default DynamicIcon;
